var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_160_363)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#007AB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1698 12.9651V17.9124H16.3014V13.2967C16.3014 12.1377 15.8873 11.3462 14.8488 11.3462C14.0562 11.3462 13.5854 11.8791 13.3775 12.395C13.302 12.5794 13.2825 12.8355 13.2825 13.0941V17.9122H10.4139C10.4139 17.9122 10.4525 10.0946 10.4139 9.28539H13.2827V10.5079C13.2769 10.5175 13.2688 10.5269 13.2637 10.5361H13.2827V10.5079C13.6639 9.92135 14.3437 9.08282 15.8678 9.08282C17.755 9.08282 19.1698 10.3158 19.1698 12.9651ZM7.4132 5.12695C6.43199 5.12695 5.79004 5.77104 5.79004 6.61727C5.79004 7.44554 6.41338 8.10824 7.37555 8.10824H7.39416C8.39462 8.10824 9.01668 7.44554 9.01668 6.61727C8.99764 5.77104 8.39462 5.12695 7.4132 5.12695ZM5.96053 17.9124H8.82801V9.28539H5.96053V17.9124Z",
    fill: "#F1F2F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_160_363"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.ffd94bc1ab5380538687b0b81f3d4f65.svg";
export { ForwardRef as ReactComponent };